export default {
  helpBuyAccount: '/v3/helpBuy/helpBuyAccount',
  accountRecord: '/v3/helpBuy/accountRecord'

}
